import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';

@Component({
  selector: 'app-logout-success',
  templateUrl: './logout-success.component.html'
})

export class LogoutSuccessComponent extends BaseComponent implements OnInit {
  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  onSubmit() {
    window.location.href = '/opsbpssecure/';
  }
}
